export const PipeCommands = {
  MAP: 'map',
  NEW: 'new',
  ROTATE: 'rotate',
  VERIFY: 'verify',
};
